<!-- eslint-disable max-len -->
<template>
  <v-container id="bonfeed-main">
    <div id="bonfeed-stars">
      <div class="bonfeed-block">
        <h1 v-if="isStarSelected">{{ getPhraseHeader }}</h1>
        <h1 v-else>Расскажи, как тебе у нас!</h1>
      </div>
      <div class="bonfeed-block">
        <v-btn v-for="n in maxStars" :key="n" @click.prevent="setStar(n)" @mouseenter.native="setHoverStar(n)" @mouseleave.native="clearHoverStar" class="mx-2 bonfeed-star-btn" fab dark small
          :color="getStarColor(n)" :aria-label="'Оценка ' + n + ' из 5'">
          <v-icon dark>{{ iconStar }}</v-icon>
        </v-btn>
      </div>
    </div>

    <v-form ref="form" v-model="isFormValid" v-if="!isFormSent">
      <v-expand-transition>
        <div id="bonfeed-greet-info" class="bonfeed-greet-card" v-if="!isStarSelected">
          <br />
          <div style="text-align: center">
            <h3>Спасибо, что помогаете</h3>
          </div>
          <br />
          <p>
            В программе «Баллы за отзыв» всё работает по дружескому принципу: ты делишься впечатлениями о визите, а мы дарим тебе 2 балла — маленький бонус в знак большой благодарности.
          </p>
          <p>
            Чтобы мы могли действительно улучшать сервис, нам особенно важны живые и конкретные истории: когда ты был(а) в кофейне, что произошло, что порадовало или что можно сделать ещё лучше.
          </p>
          <p>
            Мы читаем каждый отзыв — с вниманием и искренним интересом! Но разобрать сможем только те, в которых есть конкретика. Если деталей нет, мы просто не поймём, что улучшать.
          </p>
          <p>
            Ты можешь прислать нам до 10 отзывов в месяц — мы правда рады каждому! Спасибо, что ты с нами!
          </p>
          <p style="text-align: right">
            С любовью и ароматом свежего кофе, твой КофеБон!
          </p>
        
        </div>
      </v-expand-transition>

      <v-expand-transition>
        <div class="bonfeed-block" v-if="isStarSelected">
          <div id="bonfeed-phrases" class="bonfeed-block">
            <h4>{{ getPhraseText }}</h4>
          </div>

          <div id="bonfeed-notes" class="bonfeed-block">
            <h3>{{ getPhraseWhatNext }}</h3>
            <div id="bonfeed-notes-container">
              <div class="bonfeed-note" v-for="(note, n) in notes" :key="n" @click="toggleNote(n)">
                <div class="bonfeed-note-icon">
                  <v-btn fab dark x-small :color="isNoteSelected(n) ? getNoteSelectedColor : 'grey'">
                    <v-icon dark>{{ note['icon'] }}</v-icon>
                  </v-btn>
                </div>
                <div class="bonfeed-note-label">{{ note['name'] }}</div>
              </div>
            </div>
          </div>
        </div>
      </v-expand-transition>

      <v-expand-transition>
        <div id="bonfeed-metro" v-show="isNotesSelected">
          <h3>Выберите станцию метро</h3>
          <div class="bon-store-select">
            <v-overflow-btn
              :items="metroSelectItems"
              label="Станция метро"
              editable
              v-model="resultMetro"
              @change="onMetroChange"
              :rules="[(v) => !!v || 'Пожалуйста, укажите станцию метро']"
            ></v-overflow-btn>
          </div>
          <v-alert v-if="shopsLoadError" type="error" class="mt-2">
            Не удалось загрузить список. Обновите страницу или попробуйте позже.
          </v-alert>
        </div>
      </v-expand-transition>

      <v-expand-transition>
        <div id="bonfeed-store" v-show="isNotesSelected && isMetroSelected">
          <h3>В какой кофейне Вы были?</h3>
          <StoreSelector
            :stores="filteredStoresForSelector"
            v-on:storeSelected="(v) => (this.resultStore = v)"
          />
        </div>
      </v-expand-transition>

      <v-expand-transition>
        <div id="bonfeed-date" v-show="isNotesSelected && isStoreSelected">
          <h3>Когда Вы были в кофейне?</h3>
          <DateSelector v-on:dateSelected="(v) => (this.resultDate = v)" />
        </div>
      </v-expand-transition>

      <v-expand-transition>
        <div id="bonfeed-comment" v-show="isNotesSelected && isStoreSelected && isDateSelected">
          <v-textarea v-model="resultComment" label="Пожалуйста, укажите подробности" auto-grow clearable rows="2"
            row-height="25" :rules="rulesComment"></v-textarea>
        </div>
      </v-expand-transition>

      <v-expand-transition>
        <div id="bonfeed-footer" v-show="isNotesSelected">
          <div id="bonfeed-contacts">
            <div id="bonfeed-contacts-phone">
              <v-text-field v-model="resultPhone" label="Ваш номер телефона" v-mask="'(###) ###-##-##'" prefix="+7 "
                placeholder="(xxx) xxx-xx-xx" hint="(xxx) xxx-xx-xx" :rules="[validatePhone]" type="tel"></v-text-field>
            </div>

            <div id="bonfeed-contacts-name">
              <v-text-field v-model="resultName" label="Ваше имя" required :rules="rulesName"></v-text-field>
            </div>
          </div>

          <v-expand-transition>
            <div v-if="ajaxError" class="bonfeed-error-block">
              <v-alert type="error">
                Произошла ошибка сохранения данных, пожалуйста повторите попытку.
              </v-alert>
              <v-btn class="mt-2" color="red" outlined @click="ajaxError = false; sendForm()">
                Повторить отправку
              </v-btn>
            </div>
          </v-expand-transition>

          <div id="bonfeed-submit">
            <v-btn class="white--text" name="submit-button" :disabled="!readyToSubmit" @click="sendForm" color="red"
              large>Отправить отзыв!</v-btn>
          </div>
        </div>
      </v-expand-transition>
    </v-form>
    <div v-else id="bonfeed-accepted">
      <h2>{{ finishText }}</h2>
      <br />
      <p v-if="currentStarSelected < 4">
        Нам потребуется некоторое время, что бы исправить ситуацию. В течение двух дней, на номер
        <b>{{ resultPhone }}</b> будет зачислено 2 балла.
      </p>
    </div>
  </v-container>
</template>


<script>
import {
  mdiStar,
  mdiAccount,
  mdiTimerOutline,
  mdiFoodCroissant,
  mdiCoffeeOutline,
  mdiHomeOutline,
  mdiHelp,
} from '@mdi/js';

import StoreSelector from './StoreSelector';
import DateSelector from './DateSelector';
import { API_ENDPOINTS } from '../config';

export default {
  name: 'FeedBackForm',

  components: {
    StoreSelector,
    DateSelector,
  },

  methods: {
    async loadShops() {
      this.shopsLoading = true;
      this.shopsLoadError = false;
      try {
        const res = await this.$http.get(API_ENDPOINTS.shops);
        if (res?.data && Array.isArray(res.data)) {
          this.allStores = res.data;
        }
      } catch (err) {
        this.shopsLoadError = true;
      } finally {
        this.shopsLoading = false;
      }
    },
    onMetroChange() {
      this.resultStore = 0;
    },
    async sendForm() {
      try {
        this.ajaxLoading = true;
        this.ajaxError = false;

        const { data } = await this.$http.patch(
          API_ENDPOINTS.feedback,
          this.buildResultForm()
        );
        if (data.match(/^ok/)) {
          this.isFormSent = true;
        } else {
          this.ajaxError = true;
        }
      } catch (err) {
        this.ajaxError = true;
        if (process.env.NODE_ENV !== 'production') {
          console.warn('Feedback submit error:', err);
        }
      } finally {
        this.ajaxLoading = false;
      }
    },
    setStar(v) {
      if (this.isFormSent) return;
      this.currentStarSelected = v;
    },
    setHoverStar(n) {
      if (this.isFormSent) return;
      this.hoverStar = n;
    },
    clearHoverStar() {
      this.hoverStar = 0;
    },
    getStarColor(n) {
      if (this.currentStarSelected > 0) {
        return n <= this.currentStarSelected ? 'red' : 'grey';
      }
      if (this.hoverStar > 0) {
        return n <= this.hoverStar ? 'amber darken-2' : 'grey';
      }
      return 'grey';
    },
    toggleNote(n) {
      const setTo = this.notes[n].selected === 0 ? 1 : 0;
      this.notes[n].selected = setTo;
      if (setTo === 1) {
        this.notesCount++;
      } else {
        this.notesCount--;
      }
    },
    isNoteSelected(n) {
      return this.notes[n].selected !== 0;
    },
    validatePhone() {
      if (!this.resultPhone) return 'Номер обязательно нужен';
      if (this.unmaskedPhone.length !== 10) return 'Номер телефона 10 знаков';
      return true;
    },
    formatPhoneForMask(digits10) {
      if (String(digits10).length !== 10) return digits10;
      const s = String(digits10);
      return `(${s.slice(0, 3)}) ${s.slice(3, 6)}-${s.slice(6, 8)}-${s.slice(8, 10)}`;
    },
    buildResultForm() {
      const nn = [];

      Object.keys(this.notes).forEach((key) => {
        if (this.notes[key].selected) {
          nn.push(key);
        }
      });

      return {
        stars: this.currentStarSelected,
        comment: this.resultComment,
        name: this.resultName,
        phone: this.unmaskedPhone,
        notes: nn.join(','),
        visit_date: this.resultDate,
        store_num: this.resultStore,
        source: this.source,
      };
    },
  },
  computed: {
    finishText() {
      return this.currentStarSelected === 1 || this.currentStarSelected >= 4
        ? 'Спасибо, стараемся для вас каждый день!'
        : 'Спасибо, Ваш отзыв успешно принят!';
    },
    isStarSelected() {
      return this.currentStarSelected > 0;
    },
    getNoteSelectedColor() {
      // return ( this.currentStarSelected == 5 ? 'green' : 'red');
      return 'red';
    },
    getPhraseHeader() {
      return this.phrases[this.currentStarSelected]['header'];
    },
    getPhraseText() {
      return this.phrases[this.currentStarSelected]['text'];
    },
    getPhraseWhatNext() {
      return this.phrases[this.currentStarSelected]['what-next'];
    },
    unmaskedPhone() {
      return this.resultPhone.replace(/\D+/g, '');
    },
    metroList() {
      if (!this.allStores.length) return [];
      const names = [...new Set(this.allStores.map((s) => s.subway_name).filter(Boolean))];
      return names.sort((a, b) => String(a).localeCompare(b));
    },
    metroSelectItems() {
      if (this.shopsLoading) {
        return [{ text: 'Загрузка списка...', value: '' }];
      }
      if (!this.metroList.length) {
        return [{ text: 'Нет данных', value: '' }];
      }
      return this.metroList.map((name) => ({ text: name, value: name }));
    },
    filteredStoresForSelector() {
      if (!this.resultMetro || !this.allStores.length) return [];
      return this.allStores
        .filter((s) => s.subway_name === this.resultMetro)
        .map((s) => ({ text: s.address, value: s.number }));
    },
    readyToSubmit() {
      return (
        this.isStarSelected &&
        this.isNotesSelected &&
        this.isDateSelected &&
        this.isFormValid &&
        !this.ajaxLoading
      );
    },
    isNotesSelected() {
      return this.notesCount > 0;
    },
    isMetroSelected() {
      return !!this.resultMetro;
    },
    isStoreSelected() {
      return this.resultStore > 0;
    },
    isDateSelected() {
      return this.resultDate !== '';
    },
  },
  data: () => ({
    iconStar: mdiStar,
    ajaxError: false,
    ajaxLoading: false,
    source: '',
    isFormSent: false,
    maxStars: 5,
    currentStarSelected: 0,
    hoverStar: 0,
    isFormValid: false,
    resultComment: '',
    resultName: '',
    resultPhone: '',
    resultDate: '',
    resultMetro: '',
    resultStore: 0,
    notesCount: 0,
    allStores: [],
    shopsLoading: true,
    shopsLoadError: false,
    notes: {
      'note-barista': { name: 'Бариста', icon: mdiAccount, selected: 0 },
      'note-speed': { name: 'Скорость обслуживания', icon: mdiTimerOutline, selected: 0 },
      'note-product': { name: 'Наши угощения', icon: mdiFoodCroissant, selected: 0 },

      'note-coffee-taste': { name: 'Вкус напитка', icon: mdiCoffeeOutline, selected: 0 },
      'note-atmosphere': { name: 'Атмосфера в кофейне', icon: mdiHomeOutline, selected: 0 },
      'note-other': { name: 'Другое', icon: mdiHelp, selected: 0 },
    },
    phrases: {
      1: {
        header: 'Очень плохо',
        text: 'Пожалуйста, помогите нам исправиться! =(',
        'what-next': 'Что надо срочно исправить?',
      },
      2: {
        header: 'Плохо',
        text: 'Огромное Спасибо! Срочно исправимся!',
        'what-next': 'Что мы так сильно упустили?',
      },
      3: {
        header: 'Нормально',
        text: 'Спасибо! Так не должно быть! Исправим!',
        'what-next': 'Что Вам не понравилось?',
      },
      4: {
        header: 'Хорошо',
        text: 'Мы рады что Вам понравилось :-)',
        'what-next': 'В чём наши недоработки?',
      },
      5: {
        header: 'Отлично',
        text: 'Спасибо за оценку отлично! :-)',
        'what-next': 'Однако, что можно улучшить?',
      },
    },
    rulesName: [(v) => !!v || 'Имя обязательный параметр'],
    rulesComment: [(v) => !!v || 'Нам очень нужна детальная информация'],
  }),
  mounted() {
    this.loadShops();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const card = urlParams.get('client_card');
    let name = urlParams.get('client_name');
    let phone = urlParams.get('client_phone');

    // Our url might look like this: https://www.coffeebon.ru/mnenie/003
    // in that case source will be '003'
    // or it might look like this: https://www.coffeebon.ru/mnenie/?m=004
    // in that case source will be '004'
    const sourceFromPath = window.location.pathname.split('/').pop();
    this.source = urlParams.get('m') || sourceFromPath;

    if (localStorage) {
      if (!name && localStorage.clientName) {
        name = localStorage.clientName;
      }
      if (!phone && localStorage.clientPhone) {
        phone = localStorage.clientPhone;
      }
    }

    if (name) {
      this.resultName = name;
    }
    if (phone) {
      phone = phone.replace(/\D+/g, '');
      const cutPhone = phone.substr(phone.length - 10);
      if (cutPhone.length === 10) {
        this.resultPhone = this.formatPhoneForMask(cutPhone);
      }
    }
  },
  watch: {
    resultMetro() {
      this.resultStore = 0;
    },
    resultName(newName) {
      if (localStorage) {
        localStorage.clientName = newName;
      }
    },
    resultPhone(newPhone) {
      if (localStorage) {
        localStorage.clientPhone = newPhone;
      }
    },
  },
};
</script>

<style scoped>
#bonfeed-main {
  max-width: 600px;
  /*background: lightgray;*/
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}

#bonfeed-greet-info.bonfeed-greet-card {
  max-width: 36em;
  margin: 0 auto 2rem;
  padding: 1.75rem 1.5rem;
  background: #fafafa;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  line-height: 1.65;
}

#bonfeed-greet-info.bonfeed-greet-card .bonfeed-greet-subtitle {
  color: #5a5a5a;
  font-size: 1.05rem;
  margin-bottom: 1.25rem;
}

#bonfeed-greet-info p {
  text-indent: 0;
  margin-bottom: 1rem;
  color: #333;
}

#bonfeed-greet-info p:last-of-type {
  margin-bottom: 0;
}

.bonfeed-star-btn {
  transition: transform 0.15s ease, background-color 0.15s ease !important;
}

.bonfeed-star-btn:hover {
  transform: scale(1.08);
}

.bonfeed-block {
  margin-bottom: 2rem;
  text-align: center;
}

#bonfeed-notes-container {
  /* column-count: 2;
  column-gap: 1%;
  column-fill: auto;
*/
  margin-left: auto;
  margin-right: 0px;
  margin-top: 0.7rem;

  max-height: 10rem;
  display: flex;
  flex-flow: column wrap;
}

.bonfeed-note {
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 50%;
}

.bonfeed-note-icon {
  margin: 0.5rem;
}

.bonfeed-note-label {
  margin: 0.5rem;
  font-size: small;
  text-align: left;
}

#bonfeed-comment {
  /* max-width: 80%; */
  margin-left: auto;
  margin-right: auto;
}

#bonfeed-contacts {
  /* max-width: 80%; */
  margin-top: 1rem;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#bonfeed-metro,
#bonfeed-store {
  /* max-width: 80%; */
  margin-top: 2rem;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

#bonfeed-date {
  /* max-width: 80%; */
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.bonfeed-error-block {
  margin-bottom: 1rem;
}

#bonfeed-submit {
  margin-top: 2rem;
  text-align: center;
}

#bonfeed-accepted {
  margin-top: 2rem;
  text-align: center;
}
</style>
